/**
 * 角色权限管理 API
 */
import http from './httpRequest.js'

/**
 * 获取角色列表
 */
export function getRoleList() {
  return http({
    url: '/role/list',
    method: 'GET'
  })
}

/**
 * 获取角色权限
 */
export function getRolePermissions(roleCode) {
  return http({
    url: `/role/permissions/${roleCode}`,
    method: 'GET'
  })
}

/**
 * 获取工作台模块列表
 */
export function getWorkbenchModules() {
  return http({
    url: '/role/workbench/modules',
    method: 'GET'
  })
}

/**
 * 保存角色权限
 */
export function saveRolePermissions(roleCode, permissions) {
  return http({
    url: '/role/savePermissions',
    method: 'POST',
    data: { roleCode, permissions }
  })
}

/**
 * 新增角色
 */
export function addRole(data) {
  return http({
    url: '/role/add',
    method: 'POST',
    data
  })
}

/**
 * 更新角色
 */
export function updateRole(data) {
  return http({
    url: '/role/update',
    method: 'PUT',
    data
  })
}

/**
 * 删除角色
 */
export function deleteRole(roleCode) {
  return http({
    url: `/role/${roleCode}`,
    method: 'DELETE'
  })
}

/**
 * 获取角色列表（含员工数量）
 */
export function getRoleListWithCount() {
  return http({
    url: '/role/listWithCount',
    method: 'GET'
  })
}

/**
 * 获取当前用户PC端权限
 */
export function getMyPcPermissions() {
  return http({
    url: '/user/pcPermissions',
    method: 'GET'
  })
}

/**
 * 获取当前用户APP端权限
 */
export function getMyAppPermissions() {
  return http({
    url: '/user/appPermissions',
    method: 'GET'
  })
}

/**
 * 初始化所有角色的默认权限
 */
export function initDefaultPermissions() {
  return http({
    url: '/role/initDefaultPermissions',
    method: 'POST'
  })
}
